import { render, staticRenderFns } from "./RequisitionStateCard.vue?vue&type=template&id=519305c5&"
import script from "./RequisitionStateCard.vue?vue&type=script&lang=ts&"
export * from "./RequisitionStateCard.vue?vue&type=script&lang=ts&"
import style0 from "./RequisitionStateCard.vue?vue&type=style&index=0&id=519305c5&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports